import { EVENTS } from '@/shared/constants/commons.js'
import { initChatWidget } from '../chatInit.js'

class OnUserConnected {
  static register(context) {
    context.events.handle(EVENTS.USER_CONNECTED, async () => {
      console.log('🔥 OnUserConnected - USER_CONNECTED event fired, initializing chat widget')
      try {
        await initChatWidget()
      } catch (error) {
        console.error('❌ OnUserConnected - Failed to init chat widget:', error)
      }
    })
  }
}
export default OnUserConnected
